import React from 'react';
import { SubcategoryPage } from './components/SubcategoryPage';

import './index.scss';

export default function SubCategories() {
  return <SubcategoryPage />;
}
